import { CancelToken } from 'axios';

import shortid from 'shortid';
import { API_URL } from '../../../shared/config/config';
import BaseRequest from '../../../shared/http-requests/BaseRequest';
import { BookDetails } from '../interfaces/AccessibilitySearchDetailsInterfaces';

const ServiceBaseUrl = `${API_URL}/accessibility`;

export const getSearch = (
    search_text: string,
    accessibleTitleSearch: 'S' | 'N',
    cancelToken?: CancelToken,
) => {
    const search_id = shortid.generate();
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/search`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
        params: {
            search_id,
            search_text,
            accessibleTitleSearch,
        },
    });
};

export const getFilters = (cancelToken?: CancelToken) => {
    return BaseRequest.axiosInst.get(`${ServiceBaseUrl}/filters`, {
        headers: BaseRequest.publicHeaders,
        cancelToken,
    });
};

export const getCollectionDetails = (
    codAcervo: string,
    codBiblioteca: string | null = null,
    cancelToken?: CancelToken,
): Promise<{ data: BookDetails }> => {
    return BaseRequest.axiosInst.get(
        `${ServiceBaseUrl}/collection/${codAcervo}/details`,
        {
            headers: BaseRequest.publicHeaders,
            cancelToken,
            params: {
                codBiblioteca,
            },
        },
    );
};

export const getExemplaryLibraries = (codAcervo: string, cancelToken?: CancelToken)=> {
    return BaseRequest.axiosInst.get(
        `${ServiceBaseUrl}/collection/${codAcervo}/libraries`,
        {
            headers: BaseRequest.publicHeaders,
            cancelToken,
        },
    );
}
